<!--搜索框，自动添加label-->
<template>
  <div class="vm-search-com">
    <div v-if="label" :style="labelStyle" class="vm-search-label">
      <span v-if="title" :title="title">{{label}}</span>
      <span v-else>{{label}}</span>
    </div>
    <div :style="{width: valueWidth+'px'}">
      <slot/>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      label: {
        type: String,
      },
      labelWidth: {
        type: Number,
        default: 0,
      },
      labelColor: {
        type: String,
        default: "",
      },
      valueWidth: {
        type: Number,
        default: 100,
      },
      title: {
        type: String,
        default: "",
      },
    },
    data() {
      return {};
    },
    computed: {
      labelStyle: function() {
        return {
          width: this.labelWidth === 0 ? "auto" : this.labelWidth + "px",
          color: this.labelColor,
        };
      },
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
.vm-search-com {
  display: inline-flex;
  margin: 2px 0;
  align-items: center;

  .vm-search-label {
    box-sizing: border-box;
    display: inline-block;
    font-size: 12px;
    color: #333;
    line-height: 28px;
    padding-left: 6px;
    padding-right: 3px;
    white-space: nowrap;
    text-align: right;
  }
}
</style>
<style lang="scss">
.vm-search-com {
  .el-checkbox {
    margin-top: 1px;
  }

  .el-select, .el-input {
    flex: 1;
  }

  .el-input:not(.el-date-editor) .el-input__inner {
    padding: 0 5px;
  }

  .el-date-editor.el-input--prefix {
    .el-input__inner {
      padding-left: 25px;
    }

    .el-input__prefix {
      left: 0;
    }
  }

  .el-date-editor.el-input--suffix {
    .el-input__inner {
      padding-right: 10px;
    }

    .el-input__suffix {
      right: 0;
    }
  }
}
</style>
